export default class PageRequest {
	page: number = 0
	pageSize: number = 10
}
